import { useAsyncData } from '#imports'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useFetchProductSourceUrl } from '~/scopes/product-core/composables/useFetch/useFetchProductSourceUrl/useProductSourceUrl'

export function useFetchLinkBooster() {
  const $httpFetch = useHttpFetch()
  const productPageUrl = useFetchProductSourceUrl()

  return useAsyncData(
    getAsyncDataKey('pp_linkboosters', {
      path: productPageUrl.value,
    }),

    async () =>
      await $httpFetch('/internal-links/v1/link-boosters', {
        query: {
          source_url: productPageUrl.value,
        },
        timeout: 500,
      }),
    {
      dedupe: 'defer',
      default: () => [],
      transform: (data) =>
        data.linkLists
          .find((list) => list.listId === 'pp_linkboosters')
          ?.links.map(({ link, title }) => ({
            title,
            relativeLink: link.relativeHref,
          })) || [],
    },
  )
}
